import './App.css';
import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import GeneratePage from './Pages/GeneratePage/GeneratePage.jsx';
import SavedPage from './Pages/SavedPage/SavedPage.jsx';
import AccountPage from './Pages/AccountPage/AccountPage.jsx';
import LandingPage from './Pages/LandingPage/LandingPage.jsx';

function App() {
  // I suppose this can be either username or email here... can ask backend for it afterwards, we'll see
  const [username, setUsername] = useState(null);

  const fetchCurrentUser = async () => {
    fetch(`${BACKEND_LINK}/me`, {
        method: "GET",
        credentials: "include",
      }).then(response => {
        if(!response.ok) {
          setUsername(null);
          return;
        }
        return response.json();
      }).then(data => {
        setUsername(data.username);
      }).catch(error => {});
  };

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  const logout = async () => {
    fetch(`${BACKEND_LINK}/logout`, {
        method: "POST",
        credentials: "include",
      }).then(() => {
        setUsername(null);
      });
  };

  return (
    <Routes>
      <Route path='/' element={<LandingPage key="landing" username={username} loginFunc={() => {}} refreshUser={fetchCurrentUser}></LandingPage>}></Route>
      <Route path='/saved' element={<SavedPage key="account" username={username} logout={logout}></SavedPage>}></Route>
      <Route path="/generate/palette-idea" element={<GeneratePage key="palette-idea" username={username} setUsername={setUsername} refreshUser={fetchCurrentUser}
        hasPalette={true} hasPrompt={true} logout={logout} urltag={"palette-idea"}/>}/>
      <Route path="/generate/palette" element={<GeneratePage key="palette" username={username} setUsername={setUsername} refreshUser={fetchCurrentUser}
        hasPalette={true} hasPrompt={false} logout={logout} urltag={"palette"}/>}/>
      <Route path="/generate/idea" element={<GeneratePage key="idea" username={username} refreshUser={fetchCurrentUser}
        hasPalette={false} hasPrompt={true} logout={logout} urltag={"idea"}/>}/>
      <Route path='/account-settings' element={<AccountPage key="account-settings" logout={logout}></AccountPage>}></Route>
    </Routes>
  );
}

export const BACKEND_LINK = 'https://api.palettemuse.org';
export default App;
